<template>
    <b-navbar v-if="navItems">
        <b-navbar-nav>
            <b-nav-item
                v-for="item in navItems"
                :key="item.id"
                :to="{ name: item.routeName }"
                :active="isActiveRoute(item)"
            >
                {{ item.name }}
            </b-nav-item>
        </b-navbar-nav>
    </b-navbar>
</template>

<script>
export default {
    name: "ReNavbar",
    props: {
        /**
         * The configuration for the application menu (optional).
         * Must be and array of object, for example:
         * {
         *     id: "power",
         *     name: "Power Page",
         *     routeName: "power"
         * }
         */
        navItems: {
            type: Array,
            required: true,
        },
        /**
         * A string representing the current route.
         * It should match one of: navbarItems[i].routeName
         */
        routeName: {
            type: String,
            required: false,
        },
    },
    methods: {
        isActiveRoute(item) {
            if (!this.routeName) {
                return false;
            }
            return item.routeName === this.routeName;
        },
    },
};
</script>

<style scoped></style>
